module.exports = __webpack_public_path__ + "static/media/02.Akademy Performance Video.09c4a943.mp4";